exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* TEXTFIELD */\n\n/* LIST */\n\n/* ==========  Layout  ========== */\n\n/* BUTTON */\n\n/* ANIMATION */\n\n/* Small control size */\n\n.wrapper {\n  height: 80vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.header {\n  color: rgba(0, 0, 0, 0.87);\n  font-size: 20px;\n  padding-bottom: 16px;\n}\n\n.header .header__button {\n  float: right;\n}\n\n.content-wrapper {\n  height: 100%;\n  overflow: auto;\n  border: solid 1px #BDBDBD;\n  padding: 16px;\n}\n\n.spinner {\n  margin: auto;\n}\n\n.page {\n  width: 21cm;\n  color: #000;\n}\n\n", ""]);

// exports
